<template>
  <div class="OrderDetail">
    <template>
      <QS-H4-Title type="h4" title="订单操作" />
      <el-button
        class="contactUs"
        type="primary"
        @click="toggleContactUs"
      >联系客服</el-button>
      <el-button
        v-if="source.approvalState === 40 && source.payState === 701"
        type="primary"
        :loading="repaymentLoading"
        @click="openRepayment"
      >确认支付</el-button>
    </template>
    <template v-if="allBaseInfo.length">
      <QS-H4-Title type="h4" title="订单基本信息" />
      <column-box :source="source" :column="columnNum" :list="allBaseInfo">
      </column-box>
    </template>
    <template v-if="source.itemExtraInfo">
      <QS-H4-Title type="h4" title="商品信息" />
      <div v-if="source.cardList.length">
        <PackageCard
          v-for="item in source.cardList"
          :data="item"
          :shopType = source.shopType
          :key="item.contentId"
        />
      </div>
    </template>

    <template v-if="allFinanceInfo.length">
      <QS-H4-Title type="h4" title="财务信息" />
      <column-box :source="source" :column="columnNum" :list="allFinanceInfo">
      </column-box>
    </template>

    <template v-if="allMarketingInfo.length">
      <QS-H4-Title type="h4" title="营销" />
      <column-box :source="source" :column="columnNum" :list="allMarketingInfo">
      </column-box>
    </template>

    <template v-if="allInvoiceInfo.length">
      <QS-H4-Title type="h4" title="发票" />
      <column-box :source="source" :column="columnNum" :list="allInvoiceInfo">
      </column-box>
    </template>

    <template v-if="userInfo.length">
      <QS-H4-Title type="h4" title="用户信息" />
      <column-box :source="source" :column="columnNum" :list="userInfo">
      </column-box>
    </template>

    <template v-if="allStationInfo.length">
      <QS-H4-Title type="h4" title="维修厂信息" />
      <column-box :source="source" :column="columnNum" :list="allStationInfo">
      </column-box>
    </template>

    <template v-if="allOrderLogInfo.length">
      <QS-H4-Title type="h4" title="订单日志" />
      <table-component
        class="table-component"
        :data="source && source.orderStateLogs"
        :columns="allOrderLogInfo"
      />
    </template>

    <template
      v-if="
        source &&
        source.orderRefundLogs &&
        source.orderRefundLogs.length &&
        allRefundLogInfo.length
      "
    >
      <QS-H4-Title type="h4" title="退款日志" />
      <table-component
        class="table-component"
        v-if="source && source.orderRefundLogs"
        :data="source.orderRefundLogs"
        :columns="allRefundLogInfo"
      />
    </template>
    <ContactusDialog
      :visible="isShowContactUs"
      @close="toggleContactUs"
      :businessTel="source.businessTel"
    />
    <RepaymentDialog
      :factAmount="source.factAmount"
      :visible="isShowRepayment"
      @close="closeRepayment"
      @ok="okRepayment"
    />
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import { openNewPages } from '@/utils'
import PackageCard from '../components/PackageCard.vue'
import config from './config'
import { getOrderDetailApi, queryPurchaseAddressApi, queryPurchasePhoneApi, purchaseMallPayApi } from './services'
import dict from '@/store/dict/maintenanceOrder'
import ContactusDialog from './dialog/contactus.vue'
import RepaymentDialog from './dialog/repayment.vue'

const { orderType } = dict

export default {
  name: 'electricOrderDetailPage',
  components: {
    PackageCard,
    ContactusDialog,
    RepaymentDialog,
  },
  data() {
    const {
      allBaseInfo,
      allFinanceInfo,
      allMarketingInfo,
      allInvoiceInfo,
      userInfo,
      allStationInfo,
      allOrderLogInfo,
      allRefundLogInfo,
    } = config.call(this)
    return {
      repaymentLoading: false,
      columnNum: 2,
      orderId: '',
      allBaseInfo,
      allFinanceInfo,
      allMarketingInfo,
      allStationInfo,
      allOrderLogInfo,
      allRefundLogInfo,
      userInfo,
      source: {},
      allInvoiceInfo,
      migrateShow: false,
      isShowContactUs: false,
      isShowRepayment: false,
    }
  },
  watch: {
    migrateShow: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.allBaseInfo.splice(2, 0, {
            key: 'originOrderId',
            name: '原订单号',
            formatter: (item) => {
              if (!item) return <div>--</div>
              return (
                <div>
                  <span
                    class="clickable"
                    onClick={() => this.clickOriginalOrder(item)}
                  >
                    {item}
                  </span>
                </div>
              )
            },
          })
        }
      },
    },
  },
  methods: {
    // 联系我们显示隐藏
    toggleContactUs() {
      this.isShowContactUs = !this.isShowContactUs
    },
    // 打开确认支付
    openRepayment() {
      this.isShowRepayment = true
    },
    // 关闭确认支付
    closeRepayment() {
      this.isShowRepayment = false
    },
    // 确认支付
    okRepayment() {
      purchaseMallPayApi({ orderId: this.source.orderId }).then((res) => {
        if (res && res.code === 1) {
          this.isShowRepayment = false
          this.$message.success('已提交')
        }
      })
    },
    clickOriginalOrder(orderId) {
      const params = {
        path: '/order/maintenance/detail',
        query: {
          orderId,
        },
      }
      openNewPages(params, this)
    },
    getDetail(params) {
      getOrderDetailApi(params).then(({ code, data }) => {
        if (code === 1) {
          const result = data
          if (result.count > 1 && result.itemName) {
            result.itemName += '等服务'
          }

          let businessCoupon = ''

          if (result.couponInfo) {
            if (result.couponInfo.thresholdType === 1) {
              businessCoupon = `无门槛减${result.couponInfo.discountAmount || '--'}(${result.couponInfo.merchantCouponName || '--'}${result.couponInfo.couponTemplateId || '--'}_${result.couponInfo.merchantCouponId || '--'})`
            } else if (result.couponInfo.thresholdType === 2) {
              businessCoupon = `订单满${result.couponInfo.thresholdAmount || '--'} 减${result.couponInfo.discountAmount || '--'}(${result.couponInfo.merchantCouponName || '--'}${result.couponInfo.couponTemplateId || '--'}_${result.couponInfo.merchantCouponId || '--'})`
            } else {
              businessCoupon = '--'
            }
          }

          this.source = {
            ...result,
            orderTypeText: orderType[data.orderType],
            vin: data.carInfo ? data.carInfo.vin : '--',
            spCompanyId: data.itemExtraInfo ? data.itemExtraInfo.spCompanyId : '--',
            spCompanyName: data.itemExtraInfo ? data.itemExtraInfo.spCompanyName : '--',
            originOrderId: result?.moveOrderInfo?.originOrderId,
            businessCoupon,
            merchantCouponAmount: result?.couponInfo?.merchantCouponAmount,
            shopType: 0,
            cardList: [],
          }

          if (data.itemExtraInfo && data.itemExtraInfo.skuList) {
            // 单品
            this.source.shopType = 1
            this.source.cardList = data.itemExtraInfo.skuList
          } else if (data.itemExtraInfo && data.itemExtraInfo.multiTimes) {
            // 套餐
            this.source.shopType = 2
            this.source.cardList = data.itemExtraInfo.multiTimes
          }

          this.source.lnglat =
            `${result.currentLongitude},${result.currentLatitude}`
        }
      })
    },
    // 根据经纬度查询省市区县
    // eslint-disable-next-line vue/no-unused-properties
    getRegeoByLngLat() {
      const current = this.userInfo.filter((item) => item.key === 'lnglat')[0]
      current.viewBtn.loading = true

      queryPurchaseAddressApi({
        longitude: this.source.currentLongitude,
        latitude: this.source.currentLatitude,
      }).then(({ data, code }) => {
        if (code !== 1) {
          return
        }

        let isHaveCurrentAddress = false
        this.userInfo.forEach((item) => {
          if (item.key === 'currentAddress') {
            isHaveCurrentAddress = true
          }
        })

        if (!isHaveCurrentAddress) {
          this.userInfo.push({
            key: 'currentAddress',
            name: '省市区街道',
          })
        }
        this.source.currentAddress = data.address
      }).finally(() => {
        current.viewBtn.loading = false
      })
    },
    // 获取用户手机号
    // eslint-disable-next-line vue/no-unused-properties
    getMobile() {
      const current = this.userInfo.find(
        (item) => item.key === 'userNumber',
      )
      current.viewBtn.loading = true
      queryPurchasePhoneApi({
        userId: this.source.userId,
      }).then(({ code, data }) => {
        if (code === 1) {
          this.source.userNumber = data
        }
      }).finally(() => {
        current.viewBtn.loading = false
      })
    },
  },
  mounted() {
    const { orderId, migrateShow } = this.$route.query
    if (!orderId) {
      this.$router.back()
    }
    this.orderId = orderId
    this.migrateShow = !!Number(migrateShow)
    this.getDetail({ orderId, businessType: 300 })
  },
}
</script>
<style scoped lang="less">
.column-box {
  margin: 16px 16px 0;
}
.table-component {
  margin: 16px 0;
}
.show-mobile {
  width: 80px !important;
  justify-content: center;
}
.el-steps {
  padding: 16px 0;
}
.OrderDetail {
  position: relative;
  width: calc(100% - 10px);
  .callback-btns {
    margin-left: -24px;
    padding-top: 6px;
    position: fixed;
    bottom: 0;
    height: 46px;
    background: #fff;
    width: 100%;
    text-align: center;
    border-top: 1px solid #ddd;
    z-index: 2000;
    > .el-button {
      margin-left: -48px;
    }
  }
}
.contactUs {
  margin-bottom: 15px;
  margin-left: 10px;
}
.column-cont {
  .clickable {
    cursor: pointer;
    color: #2e7eff;
  }
}
</style>
